<template>
  <router-view />
</template>

<script>
export default {
  name: "userAps",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
